import { View } from 'react-native';
import { Image } from 'expo-image';
import { useMemo } from 'react';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import { styleDesktop, styleDesktopImage, styleMobile, styleMobileImage } from './PhotosContainer.style';

export const PhotosContainer = ({ urls }: { urls: string[] }) => {
  const { isDesktop } = useResponsiveScreen();
  const styles = useMemo(() => {
    return {
      component: isDesktop ? styleDesktop : styleMobile,
      image: isDesktop ? styleDesktopImage : styleMobileImage,
    };
  }, [isDesktop]);

  return (
    <View style={styles.component.wrapper}>
      {urls
        .slice(0, 3)
        .reverse()
        .map((url, index, array) => {
          const imageStyle = styles.image[array.length - 1][index].photo;
          return (
            <Image style={[styles.component.image, imageStyle]} source={url} key={`photos-container_photo${index}`} />
          );
        })}
    </View>
  );
};
